import * as React from "react";
import * as TrackedExperiments from "~/contexts/trackedExperiments";
import { FlagName } from "~/domain/prefab";

export const useTrackedExperiments = () => {
  const state = React.useContext(TrackedExperiments.StateContext);
  const dispatch = React.useContext(TrackedExperiments.DispatchContext);

  const has = React.useCallback(
    (key: FlagName, value: unknown) =>
      TrackedExperiments.hasTrackedExperiment(state)(key, value),
    [state],
  );

  const add = React.useCallback(
    (key: FlagName, value: unknown) =>
      dispatch({
        type: "add",
        key,
        value,
      }),
    [dispatch],
  );

  return {
    has,
    add,
  };
};
